import React, { useState } from 'react';
import SimplePlayer from '../../../components/simple-player/SimplePlayer';
import { AssetForm } from '../../../store/forms';
import AssetFieldsWidget from '../asset-fields-widget/asset-fields-widget';

interface IProps {
  assetForm: AssetForm;
  assetFormValues: any; //  react hook form
  onSaveClick: (form: AssetForm) => void;
  onCancelClick: () => void;
  setThumbnail?: () => void;
  uploadThumbnail?: (file: File) => void;
  onFormChanged?: () => void;
  isNew?: boolean;
  rightOpen?: boolean;
  expandRightSide?: (rightOpen) => void;
}
const ClipGroupInfo = ({ assetFormValues, assetForm, onSaveClick, onFormChanged, onCancelClick, isNew,   rightOpen = false,
  expandRightSide }: IProps) => {
  const [currentTime, setCurrentTime] = useState<Number>(0);
  const onPlayerCurrentTime = (currentTime: Number) => {
    // this.currentTime = currentTime;
    // console.log('currentTime', currentTime);
    setCurrentTime(currentTime);
  };
  return (
    <div className="clip-group-info" id="clip-group-info">
      <div className="edit-asset-player">
        <SimplePlayer srcUrl={assetForm.assetSrc} onTimeUpdate={onPlayerCurrentTime} />
      </div>
      <AssetFieldsWidget
        assetFormValues={assetFormValues}
        assetForm={assetForm}
        isNew={isNew}
        onSaveClick={onSaveClick}
        onCancelClick={onCancelClick}
        onFormChanged={onFormChanged}
        rightOpen={rightOpen}
        expandRightSide={expandRightSide}
      />
    </div>
  );
};

export default ClipGroupInfo;
